import React, {useContext, useState} from 'react';
import {useNavigate} from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/login.css';
import {AuthContext} from '../config/AuthContext';
import {Button, Layout, message} from "antd";
import {Content} from "antd/es/layout/layout";
import AppFooter from "./components/AppFooter";
import AvaluacioColors from "../styles/AvaluacioColors";
import {PutUsuari} from "../dao/PutUsuari";
import {GetAlumneId} from "../dao/GetAlumneId";

const UserName = () => {
    const [usuari, setUsername] = useState('');
    const [loading, setLoading] = useState(false);
    const {
        isLoggedIn,
        setLoggedIn,
        userId,
        setUserId,
        alumne,
        setUser,
        setAlumneInfo,
        setUserPermisos
    } = useContext(AuthContext);

    const navigate = useNavigate();

    const handleUsernameChange = (event: { target: { value: React.SetStateAction<string>; }; }) => {
        setUsername(event.target.value);
    };

    const check = async (usuari: string) => {
        setLoading(true);
        if (usuari !== '') {
            await PutUsuari({...alumne.alumne, nom: usuari, curs: alumne.alumne.curs[1], grup: alumne.alumne.curs[0]});
            //console.log({...alumne.alumne, nom: usuari, curs: alumne.alumne.curs[1], grup: alumne.alumne.curs[0]});

            const alu = await GetAlumneId(alumne.alumne.id + "");
            setAlumneInfo(alu);
            if (window.location.pathname.includes(`home/aules/`)
                && window.location.pathname.includes(`projectes/`))
                navigate(window.location.pathname);
            navigate('/home');
        } else {
            message.error("S'ha d'especificar nom d'usuari");
        }
        setLoading(false);
    };

    return (
        <Layout style={{minHeight: '200vh', display: 'flex', flexDirection: 'column'}}>
            <Content style={{padding: '0 48px', flex: '1 0 auto'}}>
                <Layout style={{padding: '24px 0', background: '#fff', borderRadius: '8px'}}>
                    <div className="container login-container">
                        <h2 className="login-title">Especifica nom d'usuari:</h2>
                        <div className="form-group">
                            <input
                                type="text"
                                className="form-control"
                                id="username"
                                value={usuari}
                                onChange={handleUsernameChange}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        check(usuari);
                                    }
                                }}
                            />
                        </div>
                        <br/>
                        <Button loading={loading} style={{backgroundColor: AvaluacioColors.colors.color6}}
                                disabled={loading} onClick={() => check(usuari)}>
                            Acceptar
                        </Button>
                    </div>
                </Layout>
            </Content>
            <AppFooter/>
        </Layout>
    )
        ;
};

export default UserName;
